import { utils } from '@intrasync/utils';
import MaterialDialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
// import { PureComponent } from 'react';
import Draggable from 'react-draggable';

import Transition, { TransitionProps } from './DialogTransition';
import injectStores from 'components/RootStore/injectStores';
import type { RouterStore } from 'stores/RouterStore';
import type RootStore from 'stores/RootStore';
import type ViewStore from 'stores/ViewStore';

// import style from './dialogStyle';
interface DialogContainerProps {
  routerStore?: RouterStore;
  viewStore?: ViewStore;
  children: React.ReactNode;
  rootStore?: RootStore;
}

interface PaperComponentProps {
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}
// import style from './dialogStyle';
const DialogContainer = injectStores(
  ({ children, routerStore }: DialogContainerProps) => {
    if (!routerStore) return null;
    const {
      renderDialog,
      dialogFullScreen,
      dialogEnableDraggable,
      dialogCloseFunction,
    } = routerStore;

    if (!renderDialog) return null;

    const PaperComponent: React.FC<PaperComponentProps> = (props) => {
      if (!dialogEnableDraggable) {
        console.log('not return draggable');
        return <Paper {...props} />;
      }
      return (
        <Draggable handle="#draggable-dialog-title">
          <Paper {...props} />
        </Draggable>
      );
    };

    // Determine maxWidth: use explicit maxWidth if provided, otherwise fall back to smallDialog logic
    const dialogMaxWidth = renderDialog.maxWidth || (renderDialog.smallDialog ? 'sm' : 'xl');

    return (
      <MaterialDialog
        id={utils.uuid()}
        maxWidth={dialogMaxWidth}
        fullWidth={renderDialog.fullWidth ? true : false}
        fullScreen={dialogFullScreen}
        open={true}
        keepMounted={false}
        onClose={() => dialogCloseFunction()}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
      >
        {children}
      </MaterialDialog>
    );
  }
);

export default DialogContainer;
